import { graphql, Link, useStaticQuery } from 'gatsby';
import en from 'i18n/english';
import React from 'react';

import Container from 'components/Container/Container';
import Hero from 'components/Hero/Hero';
import Layout from 'components/Layout';
import Seo from 'components/Seo';
import TextLayoutContainer from 'components/TextLayoutContainer/TextLayoutContainer';

import { banner } from 'styles/pages/common.module.scss';

const query = graphql`
  query Payment {
    site {
      siteMetadata {
        url
        site
      }
    }
  }
`;

const PaymentsPage = () => {
  const {
    site: { siteMetadata: info },
  } = useStaticQuery(query);
  return (
    <Layout fullWidth>
      <Seo title="PAYMENT OPTIONS" />
      <Hero title="PAYMENT OPTIONS" containerClass={banner} />
      <Container withPadding>
        <TextLayoutContainer>
          <p>
            {en._258} <Link to={info.url}>{info.site}</Link> {en._259}
          </p>
          <h2>{en._260}</h2>
          <ol>
            <li>{en._261}</li>
          </ol>
          <p>{en._262}</p>
          <p>{en._263}</p>
          <ol start="2">
            <li>{en._264}</li>
          </ol>
        </TextLayoutContainer>
      </Container>
    </Layout>
  );
};

export default PaymentsPage;
